export var DEFAULT_COLOR = '#4fa94d';
